import React from "react";
import { useParams } from "react-router-dom";

import Loading from "components/Loading";
import NewWorkbookButton from "components/NewWorkbookButton";
import WorkbookListTable from "components/WorkbookListTable";

import { useWorkbooksQuery } from "./gql/Query.generated";

const WorkbookList = () => {
  const { databaseId } = useParams();
  const { loading, error, data, refetch } = useWorkbooksQuery({
    variables: { databaseId },
  });

  if (loading || error || !data) {
    return <Loading error={!!error} />;
  }

  return (
    <WorkbookListTable
      workbooks={data.getWorkbooks}
      onDeleted={() => {
        refetch();
      }}
      toolbar={<NewWorkbookButton />}
    />
  );
};

export default WorkbookList;
